import { render } from "./sider-trigger.vue?vue&type=template&id=3414e6e6"
import script from "./sider-trigger.vue?vue&type=script&lang=js"
export * from "./sider-trigger.vue?vue&type=script&lang=js"

import "./sider-trigger.vue?vue&type=style&index=0&id=3414e6e6&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__